if (typeof DynaCore_FormConfig_Form == 'undefined') {
    var DynaCore_FormConfig_Form =
    {
        partClass: 'el-form',
        partName: 'form',
        partSelector: '.el-form',

        /**
         * Inicializace objektu typu Form
         */
        init: function () {
            DynaCore_FormConfig_Form.contextMenuInit();
            DynaCore_FormConfig_Form.contextMenuInitFields();
        },

        contextMenuInit: function () {
            $('#designer')
                .off('contextmenu', DynaCore_FormConfig_Form.partSelector)
                .on('contextmenu', DynaCore_FormConfig_Form.partSelector, function (e) {
                    DynaCore_FormConfig_Form.contextMenuShow(e, this);
                    return false;
                });
        },

        contextMenuInitFields: function () {
            $('#designer').find('.el-form').each(function (i, elementPart) {
                var partId = $(elementPart).data('part-id');
                var elementFieldContainer = $(elementPart).find('.el-form-field-container');

                DynaCore_FormConfig.fieldsInitContextMenuInline(elementFieldContainer, 'forms', partId, 'fields');
            });
        },

        /**
         * Inicializace kontextoveho menu objektu typu Form
         *
         * @param e
         * @param element
         */
        contextMenuShow: function (e, element) {
            DynaBase_ContextMenu.addHeader(translate('Form'));

            // Upravit
            DynaBase_ContextMenu.addButton(translate('Edit'), 'pencil', function () {
                DynaCore_FormConfig_Form.edit(element);
            });

            DynaBase_ContextMenu.addDivider();
            DynaBase_ContextMenu.addHeader(translate('General'));

            // Vlastnosti
            DynaBase_ContextMenu.addButton(translate('Properties'), 'toggle-on', function () {
                var storageId = $(element).data('part-id');

                DynaCore_FormConfig_Properties.edit(element, DynaCore_FormConfig_Form.partName + 's', storageId);
            });

            // Nastaveni
            DynaBase_ContextMenu.addButton(translate('Settings'), 'cog', function () {
                var storageId = $(element).data('part-id');

                DynaCore_FormConfig_Settings.edit(element, DynaCore_FormConfig_Form.partName + 's', storageId);
            });

            // Odstranit
            DynaBase_ContextMenu.addButton(translate('Remove'), 'trash', function () {
                DynaCore_FormConfig_Form.delete(element);
            });

            DynaBase_ContextMenu.build(e, element);
        },

        /**
         * Pridani objektu typu Form
         *
         * @param element
         * @param elementParent
         * @returns {boolean}
         */
        add: function (element, elementParent) {
            var indexRow = $(elementParent).data('row');
            var indexCol = $(elementParent).data('col');
            var indexTab = $(elementParent).data('tab');
            var indexTabRow = $(elementParent).data('tab-row');
            var indexTabCol = $(elementParent).data('tab-col');
            var hasCard = $(elementParent).children().hasClass('el-col-card');

            if (true == hasCard) {
                elementParent = $(elementParent).children('.el-col-card').children('.card-body');
            }

            var partIndex = $(elementParent).children(DynaCore_FormConfig_Form.partSelector).length;

            $.ajax({
                type: 'get',
                url: window.location.href.replace('/form-config/', '/form-config/part-add/'),
                data: {
                    _ch: $('#_ch').val(),
                    pa: DynaCore_FormConfig_Form.partName,
                    r: indexRow,
                    c: indexCol,
                    t: indexTab,
                    tr: indexTabRow,
                    tc: indexTabCol,
                    paIn: partIndex
                },
                dataType: "json",
                success: function (data) {
                    var html = '';
                    if (parseInt($(elementParent).data('tab-row')) >= 0) {
                        html += '<div class="el ' + DynaCore_FormConfig_Form.partClass + '" data-row="' + indexRow + '" data-col="' + indexCol + '" data-tab="' + indexTab + '" data-tab-row="' + indexTabRow + '" data-tab-col="' + indexTabCol + '" data-part-index="' + data.paIn + '" data-part-id="' + data.paId + '">';
                        html += '    <span class="description">' + translate('Form') + '</span>';
                        html += '    <ul class="el-' + DynaCore_FormConfig_Form.partName + '-field-container list-unstyled"></ul>';
                        html += '</div>';
                    } else {
                        html += '<div class="el ' + DynaCore_FormConfig_Form.partClass + '" data-row="' + indexRow + '" data-col="' + indexCol + '" data-part-index="' + data.paIn + '" data-part-id="' + data.paId + '">';
                        html += '    <span class="description">' + translate('Form') + '</span>';
                        html += '    <ul class="el-' + DynaCore_FormConfig_Form.partName + '-field-container list-unstyled"></ul>';
                        html += '</div>';
                    }

                    $(elementParent).append(html);

                    DynaCore_FormConfig.init();
                }
            });
        },

        /**
         * Upraveni objektu typu Form
         *
         * @param element
         */
        edit: function (element) {
            var partId = $(element).data('part-id');
            var target = DynaBase_Url.getPart(0);
            var targetAlias = DynaBase_Url.getPart(1);
            var url = window.location.href.replace('/form-config/', '/form-config/part-edit/') + '?_ch=' + $('#_ch').val() + '&ta=' + target + '&taAl=' + targetAlias + '&pa=' + DynaCore_FormConfig_Form.partName + '&paId=' + partId;

            $(document).load(url, function (form) {
                Lemo_Modal
                    .setId('modal-container-formconfig-form-edit')
                    .setTitle('Edit form')
                    .setContent(form)
                    .setSize('large')
                    .addButton('change', '<i class="fas fa-fw fa-check"></i> ' + translate('Change'), 'btn btn-primary', function () {
                        var elFieldSectionContainer = $(element).find('ul.el-' + DynaCore_FormConfig_Form.partName + '-field-container');

                        $(elFieldSectionContainer).html('');
                        $('#forms-fields').find('> .btn').each(function (i, el) {
                            $(elFieldSectionContainer).append('<li class="el el-' + DynaCore_FormConfig_Form.partName + '-field btn btn-sm btn-outline-dark" data-part-id="' + $(el).data('field-id') + '" data-part-index="' + $(el).data('field') + '">' + $(el).text() + '</li>');
                        });

                        Lemo_Alert.addSuccess('Form has been successfully updated', 'formConfigFormEditSuccess');
                        Lemo_Modal.close();
                    })
                    .addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Cancel'), 'btn btn-secondary', function () {
                        Lemo_Modal.close();
                    });

                Lemo_Modal.build();

                // Inicializace
                DynaCore_FormConfig.fieldsInit('fields', 'forms', partId);
            });
        },

        /**
         * Smazani objektu typu Form
         *
         * @param element
         */
        delete: function (element) {
            var indexRow = $(element).data('row');
            var indexCol = $(element).data('col');
            var indexTab = $(element).data('tab');
            var indexTabRow = $(element).data('tab-row');
            var indexTabCol = $(element).data('tab-col');
            var partId = $(element).data('part-id');
            var partIndex = $(element).data('part-index');

            Lemo_Modal
                .setId('modal-container-formconfig-form-delete')
                .setTitle('Remove form')
                .setContent('<p class="text">' + translate('Do you really want to remove selected form?') + '</p>')
                .addButton('remove', '<i class="fas fa-fw fa-trash"></i> ' + translate('Remove'), 'btn btn-danger', function () {
                    $.ajax({
                        type: 'get',
                        url: window.location.href.replace('/form-config/', '/form-config/part-delete/'),
                        data: {
                            _ch: $('#_ch').val(),
                            pa: DynaCore_FormConfig_Form.partName,
                            r: indexRow,
                            c: indexCol,
                            t: indexTab,
                            tr: indexTabRow,
                            tc: indexTabCol,
                            paIn: partIndex,
                            paId: partId
                        },
                        dataType: "json",
                        success: function () {
                            if ($(element).parent('.card-body').parent(DynaCore_FormConfig_Form.partSelector + '-card').length > 0) {
                                element = $(element).parent('.card-body').parent(DynaCore_FormConfig_Form.partSelector + '-card');
                            }

                            $(element).remove();

                            DynaCore_FormConfig.reindex();
                        },
                        complete: function () {
                            Lemo_Modal.close();
                        }
                    });
                })
                .addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Cancel'), 'btn btn-secondary', function () {
                    Lemo_Modal.close();
                });

            Lemo_Modal.build();
        }
    }
}